import React, { useContext } from 'react';
import { Link } from 'gatsby';
import { KiteIcon } from '@kite/react-kite';
import { IMedia } from '../../utils/models';
import classNames from 'classnames';

// Tracking
import { AnalyticsContext } from '../../analytics/AnalyticsContext';
import initTealiumTracker from 'tealium-tracker';

// Helpers
import { getLinkPath, getExternalLinkPath } from '../../utils/helpers';

// Hooks
import { useVisitId } from '../../hooks/useVisitId';
import useContextToken from '../../hooks/useContextToken';

// Styles
import './FeaturedTitlesCard.scss';
import useAnalytics from '../../hooks/useAnalytics';

let tealiumTrackEvent;
if (typeof window !== 'undefined') {
  const { trackEvent } = initTealiumTracker({ debugMode: true });
  tealiumTrackEvent = trackEvent;
}

interface IFeaturedTitlesCardProps {
  id: string;
  title: string;
  description: string;
  shortDescription: string;
  item: IMedia;
  hasSwimlane: boolean;
}

const FeaturedTitlesCard = ({
  id,
  title,
  description,
  shortDescription,
  item,
  hasSwimlane,
}: IFeaturedTitlesCardProps) => {
  const analytics = useAnalytics();
  const visitId = useVisitId();
  const { contextToken } = useContextToken();

  return (
    <section
      className={classNames({
        'featured-titles-card': true,
        'featured-titles-card-grid': !hasSwimlane,
      })}
    >
      <img
        src={`https://cdnimg.spectrum.net/imageserver/program/${id}?twccategory=Hero&height=249`}
        alt={`${title} image`}
        className="featured-titles-card__image"
      />
      <p className="featured-titles-card__description">
        {shortDescription || description}
      </p>
      <section className="featured-titles-card__cta-wrapper">
        {item.id !== 'MV000024510000' && (
          <Link
            to={getLinkPath(item)}
            className="featured-titles-card__more-info"
            onClick={() => {
              analytics.track('selectAction', {
                currPageElemStdName: `More Info - ${title}`,
                msgCategory: 'navigation',
                msgTriggeredBy: 'user',
                opType: 'assetSelection',
              });
              tealiumTrackEvent({
                linktype: 'featured-title-card__arrow-link',
                linkname: `More Info - ${title}`,
              });
            }}
          >
            More Info
            <KiteIcon
              id="featured-titles-card-icon"
              icon="ki-chevron-right"
              size="24px"
              fill="fff"
              className="featured-titles-card__chevron"
            />
          </Link>
        )}
        <a
          href={getExternalLinkPath(item, visitId, contextToken)}
          className="featured-titles-card__watch"
          onClick={() => {
            analytics.track('selectAction', {
              currPageElemStdName: `Watch - ${title}`,
              msgCategory: 'navigation',
              msgTriggeredBy: 'user',
              opType: 'assetSelection',
            });
            tealiumTrackEvent({
              linktype: 'featured-title-card__watch-link',
              linkname: `Watch - ${title}`,
            });
          }}
        >
          Watch
        </a>
      </section>
    </section>
  );
};

export default FeaturedTitlesCard;
